var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m2.75 2.75h18.5v6.5h-18.5z",
    stroke: "#4C5664",
    strokeWidth: 1.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#4c5664"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9.99985 12.05h6.99995v1.5h-6.99995z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.99985 16.75h5.99995v1.5h-5.99995z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.99985 12.5h-3l1.5 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8 17h-3l1.5 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m2 8.5v13.5h18v-13.5zm1.5 12v-10.5h15v10.5z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14 5.25h5v1.5h-5z"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m7 5.25h-2v1.5h2zm1 1.5h5v-1.5h-5z",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.16c864f46228416bf937ce5e688bf1eb.svg";
export { ForwardRef as ReactComponent };